import React from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { deleteDrugInventory } from "../../Redux/Thunk/drugInventoryActions";

const DrugActions = ({ drugData, setEditData, setIsPopupOpen }) => {
    const dispatch = useDispatch();

    const handleEdit = () => {
        setEditData(drugData);
        setIsPopupOpen(true);
    };

    const handleDelete = () => {

        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(deleteDrugInventory(drugData.id)).unwrap();
                Swal.fire({
                    title: "Deleted!",
                    text: "Your file has been deleted.",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1500,

                });
            }
        });
    };

    return (
        <div className="actions-container">
            <button className="btn btn-danger btn-sm delete" onClick={handleEdit}>
                <i className="bi bi-pencil"></i> Edit
            </button>
            <button className="btn btn-danger btn-sm trash" onClick={handleDelete}>
                <i className="bi bi-trash"></i> Delete
            </button>
        </div>
    );
};

export default DrugActions;